// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class AdjustedPricingPlant {
  readonly id: string;
  readonly name: string;
  readonly marketId: string;
  readonly marketName: string;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.marketId = data.marketId === undefined ? NIL_UUID : data.marketId;
    this.marketName = data.marketName === undefined ? '' : data.marketName;
  }

  static zero(): AdjustedPricingPlant {
    const zeroValues: ExcludeMethodsDeep<AdjustedPricingPlant> = {
      id: NIL_UUID,
      name: '',
      marketId: NIL_UUID,
      marketName: '',
    };
    return new AdjustedPricingPlant(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type AdjustedPricingPlantWireFormat = {
  id: string;
  name: string;
  marketId: string;
  marketName: string;
};

type NewAdjustedPricingPlantProps = PartialDeep<AdjustedPricingPlant, { recurseIntoArrays: true }>;
export const NewAdjustedPricingPlant: (
  props: NewAdjustedPricingPlantProps,
) => AdjustedPricingPlant = (props) => new AdjustedPricingPlant(props);

type NewAdjustedPricingPlantFromWireFormatProps = PartialDeep<
  AdjustedPricingPlantWireFormat,
  { recurseIntoArrays: true }
>;
export const NewAdjustedPricingPlantFromWireFormat: (
  props: NewAdjustedPricingPlantFromWireFormatProps,
) => AdjustedPricingPlant = (props) => new AdjustedPricingPlant(props);
